import { render } from "./SingleChoiceEditor.vue?vue&type=template&id=d1de0040&scoped=true"
import script from "./SingleChoiceEditor.vue?vue&type=script&lang=js"
export * from "./SingleChoiceEditor.vue?vue&type=script&lang=js"

import "./SingleChoiceEditor.vue?vue&type=style&index=0&id=d1de0040&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1de0040"]])

export default __exports__